import { SplitFactory } from '@splitsoftware/splitio';
import config from "@/config.js";
import store from '@/store'
let client = null;
export const createSplitFactory = (userId=0) => {
  return new Promise((resolve,reject)=>{
    if(client && client!==null) {
      resolve();
      return;
    }
    try{
      let factory =  SplitFactory({
        core: {
          authorizationKey: config.SPLIT_AUTHORIZATION_KEY,
        }
      });
      client = factory.client(userId);
      client.on(client.Event.SDK_READY, function() {
        client = client
        resolve();
      })
    }
    catch(err){
      reject(err)
    }
  })
};

export const getSplitKey =  (key) =>{
    var treatment = client.getTreatment(key);
    if (treatment == 'on') 
      return true
    return false
}


export const checkSPlitKey = (key) =>{
  return new Promise((resolve,reject)=>{
    if(!client){
      let currentUser = {id:0}
      if(store.getters['auth/account'].current)
        currentUser = store.getters['auth/account'].current
      createSplitFactory(currentUser.id).then(res=>{
        setTimeout(()=>{
          resolve(getSplitKey(key))
        },500)
      })
    }else{
      resolve(getSplitKey(key))
    }
  })
}